import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'cert-badge-cell-renderer',
  template: `
    @for (item of items; track item) {
      <span class="badge text-bg-secondary me-1">{{ item }}</span>
    }
  `,
  styles: ``,
  standalone: false,
})
export class BadgeCellRendererComponent implements ICellRendererAngularComp {
  items: string[] = [];

  agInit(params: ICellRendererParams<any, string[]>): void {
    this.items = params.value ?? [];
  }

  refresh(params: ICellRendererParams<any, string[]>): boolean {
    this.items = params.value ?? [];
    return true;
  }
}
